/**
 * Qui a droit à l'écran « Commandes » — décisions #40, #87.
 *
 * ## Un seul prédicat, deux surfaces
 *
 * #40 a fait du module `orders` du dashboard **la porte d'entrée** de l'écran
 * Commandes. La règle gouverne donc deux endroits : ce que le dashboard affiche,
 * et ce que le registre d'écrans de #17 rend éligible. L'écrire deux fois
 * garantirait qu'elles divergent — d'où ce module **feuille** (aucun import,
 * graphe transitif vide, contrainte de #74).
 *
 * ## « Au moins un catalogue », et pas « au moins une commande »
 *
 * Le prédicat a été inventé faute d'axe module dans le codebase — il n'existe pas
 * de `admin_has_orders`. Il mesure donc **l'équipement plutôt que l'historique**,
 * et c'est délibéré : un hôtel qui vient de configurer son premier catalogue n'a
 * encore aucune commande, et doit quand même voir l'écran. L'inverse produirait
 * une entrée de menu qui apparaît toute seule le jour de la première vente.
 *
 * Il couvre **50 établissements**, là où le module `orders` est présent sur
 * **128 dashboards sur 128** — signature du backfill de #15, pas d'une intention.
 * Le mobile est donc **plus strict que le web**, ce que #17/#19/#27 autorisent.
 *
 * ⚠️ Corollaire : le module `orders` est **masqué au rendu** sans catalogue, sans
 * carte de repli (même motif que #27 — voir `modulesDashboard.ts`). Et le
 * « + N autres, sur ordinateur » de #22 devient **faux** dès que cet écran existe
 * sur le téléphone : les autres sont à un tapotement.
 */
export function porteLesCommandes(nombreDeCatalogues: number | undefined): boolean {
    return (nombreDeCatalogues ?? 0) > 0;
}
